import { useEffect, useState } from "react";

// Resolves a media `url` to an object URL plus byte size, revoking it on
// unmount. Shared by the image/audio/video leaves.
export function useObjectUrl(url: string | undefined) {
  const [blobUrl, setBlobUrl] = useState<string>();
  const [size, setSize] = useState<number>();
  const [failedUrl, setFailedUrl] = useState<string>();

  useEffect(() => {
    if (!url) return;
    let objectUrl: string | undefined;
    const controller = new AbortController();
    void fetch(url, { credentials: "include", signal: controller.signal })
      .then((res) => (res.ok ? res.blob() : undefined))
      .then((b) => {
        if (!b) {
          setFailedUrl(url);
          return;
        }
        setSize(b.size);
        objectUrl = URL.createObjectURL(b);
        setBlobUrl(objectUrl);
      })
      .catch(() => {
        if (!controller.signal.aborted) setFailedUrl(url);
      });
    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  return { blobUrl, size, failed: url != null && failedUrl === url };
}
